<template>
  <Modal
    name="REMOVE_LINK_ASAAS_CUSTOMER_MODAL"
    :title="$t('customer.label.removeLink')"
  >
    <template v-slot:body>
      <h6 class="text-uppercase grey--text">
        {{ $t('customer.label.removeLink') }}
      </h6>
      <p class="mb-0">{{ customer.customerName }}</p>
      <small class="grey--text">
        {{ customer.customerDocument }}
      </small>

      <div class="mt-5 text-right">
        <v-btn
          @click="removeLink"
          :loading="isLoading"
          color="primary"
          elevation="0"
        >
          {{ $t('customer.label.removeLinkCustomer') }}
        </v-btn>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/app/Modal'
import FilterSearch from '@/components/filters/FilterSearch'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ModalRemoveLinkAsaasCustomer',

  props: {
    customer: {
      type: Object,
    },
  },

  components: {
    Modal,
    FilterSearch,
  },

  data() {
    return {
      selectedRealEstate: null,
    }
  },

  watch: {
    customer() {
      this.selectedRealEstate = null
    },
  },

  computed: {
    ...mapGetters(['isLoading']),
  },

  methods: {
    ...mapActions(['removeLinkAsaasCustomer']),

    removeLink() {
      this.removeLinkAsaasCustomer(this.customer.customerId)
    },
  },
}
</script>
